import { ErrorHandler, Injectable } from '@angular/core';
import { isChunkLoadError, recoverFromStaleChunk } from './stale-chunk-recovery';

/**
 * Global error handler. A stale lazy-chunk failure after a deployment is
 * recovered by purging the service-worker cache and reloading — see
 * `stale-chunk-recovery`, which the router's NavigationError path shares so
 * both recover identically and can never reload-loop.
 */
@Injectable()
export class AppErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    if (isChunkLoadError(error)) {
      recoverFromStaleChunk();
      return;
    }

    console.error('Global Error Handler:', error);
  }
}
